import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, ProductCategoryService} from '../_services';
import {CategoryComponent} from "./category.component";
import {NgxSmartModalService} from 'ngx-smart-modal';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './product-category.component.html'
})
export class ProductCategoryComponent extends CategoryComponent implements OnInit {
  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected categoryService: ProductCategoryService,
              protected alertService: AlertService,
              protected modalService: NgxSmartModalService) {
    super(router, location, route, categoryService, alertService, modalService);
    this.title = 'Product Categories';
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
